// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingWindow_overlay__uAWg-"};